import { Link  } from "react-router-dom";

const TypedLink = (props) => {
  
  const link = props.link || null;

  const className = ((props.className) ? props.className : '')+''+((props.no_url) ? ' disable-link' : '');

  const onClick = (e)=>{
    
    if (props.disableClick) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if(typeof props.onClick == 'function'){
      props.onClick(e);
    }

  };
  
  let to = '';

  if (link.type)
  {
    if (link.type[0] == '/') link.type = link.type.substring(1, link.type.length);
    to += '/' + link.type;
  }

  if (link.url)
  {
    if (link.url[0] == '/') link.url = link.url.substring(1, link.url.length);
    to += link.url[0] === '?' ? link.url : '/' + link.url;
  }
  
  return !!link 
    ? <Link className={className} onClick={(e)=>{onClick(e)}} data-type={link.type} to={`${to}`}>
        {!!link.title ? link.title : ''}
        {(props.children && !!props.children.length) ? props.children.map((element) => element) : ((typeof props.children === 'object') ? props.children : '')}
      </Link> 
    :  '';
};

export default TypedLink;